import { render, staticRenderFns } from "./ExtraFilter.vue?vue&type=template&id=2dcfc502&"
import script from "./ExtraFilter.vue?vue&type=script&lang=js&"
export * from "./ExtraFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports